import AiSprintBoardPage from "../../pages/aiDevelopment/AiSprintBoardPage";
const route={key:"aiSprintBoard",path:"/ai-development/sprints",component:AiSprintBoardPage,permission:"ai.development.read",private:true,layout:"main",icon:"faLayerGroup",group:"aiDevelopment",order:15};
export default route;
